const LearningCenter = () => {
  return (
    <div className="centered-content">Learning Center</div>
  );
};

export default LearningCenter;
